"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISubscriptionProvider = void 0;
var ISubscriptionProvider;
(function (ISubscriptionProvider) {
    ISubscriptionProvider["None"] = "none";
    ISubscriptionProvider["Icon"] = "icon";
    ISubscriptionProvider["Shop"] = "shop";
    ISubscriptionProvider["Amazon"] = "amazon";
    ISubscriptionProvider["Android"] = "android";
    ISubscriptionProvider["AndroidTv"] = "androidTv";
    ISubscriptionProvider["Ios"] = "ios";
    ISubscriptionProvider["Roku"] = "roku";
    ISubscriptionProvider["Firetv"] = "firetv";
    ISubscriptionProvider["Tvos"] = "tvos";
})(ISubscriptionProvider || (exports.ISubscriptionProvider = ISubscriptionProvider = {}));
//# sourceMappingURL=subscription-provider.js.map